import { Button, Col, Form, Input, message, Modal, Row } from "antd";
import React, { useEffect, useState } from "react";
import { getAllTasks } from "../../../service/task.service";
import { getAllSuiteData } from "../../../service/suite.service";
import { getAllUISuites } from "../../../service/uitest.service";
import {
  getAllEnvironment,
  getDataSubTypeByType,
} from "../../../service/admin.service";
import DropdownSelect from "../../../components/generic/DropdownSelect";
import {
  createNewMasterSuite,
  createNewMasterSuiteSteps,
  deleteMasterSuiteData,
} from "../../../service/mastersuite.service";
import MasterSuiteCopyTable from "./MasterSuiteCopyTable";
import { useUser } from "../../../context/UserContext";

function MasterSuiteCopyModal(props) {
  const { email } = useUser();
  const [displayName, setDisplayName] = useState("");
  const [taskList, setTaskList] = useState([]);
  const [suiteList, setSuiteList] = useState([]);
  const [uiSuiteList, setUiSuiteList] = useState([]);
  const [newlyCreatedTask, setNewlyCreatedTask] = useState(null);
  const [environments, setEnvironments] = useState([]);
  const [defaultEnvironment, setDefaultEnvironment] = useState("");
  const [environmentFolderPath, setEnvironmentsFolderPath] = useState([]);
  const [masterSuiteTable, setMasterSuiteTable] = useState([]);

  useEffect(() => {
    setDefaultEnvironment(props.defaultEnvironment);
    if (props.visible) {
      getAllTasks().then((response) => {
        setTaskList(response.data);
      });
      getAllSuiteData().then((response) => {
        setSuiteList(response.data);
      });
      getAllUISuites()
        .then((response) => setUiSuiteList(response.data || []))
        .catch(() => setUiSuiteList([]));
      getAllEnvironment().then((response) => {
        setEnvironments(response.data);
      });
      getDataSubTypeByType("Environment").then((response) => {
        let paths = response.data.filter((item) => item.name === "Folder Path");
        setEnvironmentsFolderPath(paths);
      });
    }
  }, [props.defaultEnvironment, props.visible]);
  useEffect(() => {
    setDisplayName(props.displayName);
  }, [props.displayName]);
  useEffect(() => {
    setDefaultEnvironment(props.defaultEnvironment);
  }, [props.defaultEnvironment]);
  const resetNewlyCreatedTask = () => {
    setNewlyCreatedTask(null);
  };
  const handleModalClose = () => {
    showWarning();
  };
  const showWarning = () => {
    Modal.confirm({
      title: "You will lose all the changes if you cancel",
      content: "Are you sure you want to cancel?",
      okText: "Yes",
      cancelText: "No",
      onOk() {
        props.handleModal(false);
        setDefaultEnvironment("");
        setDisplayName("");
      },
      onCancel() {
        props.handleModal(true);
      },
    });
  };
  const handleSaveData = (newData) => {
    setMasterSuiteTable(newData);
  };
  const onSave = () => {
    setDisplayName(props.displayName);
    if (masterSuiteTable.length === 0) {
      message.error("Master Suite table cannot be empty.");
      return;
    }
    if (!defaultEnvironment) {
      message.error("Default environment is mandatory.");
      return;
    }
    let masterSuiteStepData = masterSuiteTable.map((step) => {
      return {
        ...step,
        name: props.displayName,
      };
    });
    if (!displayName) {
      message.error(
        !displayName
          ? "Display name cannot be blank."
          : "Display name already exists. Please choose another.",
      );
      return;
    }
    console.log(masterSuiteTable);
    const stepReferenceSet = new Set();
    const errors = masterSuiteTable.reduce(
      (
        acc,
        { category, subcategory, type, taskName, stepReference },
        index,
      ) => {
        if (!type) {
          acc.push(`Row ${index + 1}: Type cannot be blank.`);
        }
        if (!category || !subcategory) {
          acc.push(
            `Row ${index + 1}: Category and Sub Category cannot be blank.`,
          );
        }
        if (type === "task" && !taskName) {
          acc.push(
            `Row ${index + 1}: Task Name cannot be blank when Type is provided.`,
          );
        }
        if (!stepReference) {
          acc.push(`Row ${index + 1}: Step Name cannot be blank.`);
        }
        if (stepReferenceSet.has(stepReference)) {
          acc.push(
            `Row ${index + 1}: Step Name '${stepReference}' is duplicated.`,
          );
        } else {
          stepReferenceSet.add(stepReference);
        }
        return acc;
      },
      [],
    );
    if (errors.length > 0) {
      message.error(errors.join("\n"));
      return;
    }
    deleteMasterSuiteData(displayName, { recreating: true })
      .then((deleteResponse) => {
        if (deleteResponse.status === 200) {
          createNewMasterSuite(
            displayName,
            "comments implement",
            email,
            defaultEnvironment,
          ).then((response) => {
            createNewMasterSuiteSteps(masterSuiteStepData, displayName).then(
              (stepResponse) => {
                props.getAllLibraryData();
                message.success("Master Suite updated successfully");
                props.handleModal(false);
                setDisplayName("");
                setDefaultEnvironment("");
              },
            );
          });
        }
      })
      .catch((error) => {
        message.error("Something went wrong!");
      });
  };

  const refreshTaskData = (newTask = null) => {
    getAllTasks().then((res) => {
      setTaskList(res.data);
      if (newTask) {
        setNewlyCreatedTask(newTask);
      }
    });
  };

  const onEnvironmentChange = (value) => {
    setDefaultEnvironment(value);
  };

  return (
    <div>
      <Modal
        centered
        width="90%"
        open={props.visible}
        destroyOnClose
        onCancel={handleModalClose}
        maskClosable={false}
        footer={[
          <Button key="save" onClick={onSave}>
            Save
          </Button>,
          <Button key="back" type="primary" onClick={handleModalClose}>
            Cancel
          </Button>,
        ]}
        style={{
          top: 20,
          boxShadow:
            "0 8px 16px rgba(0, 0, 0, 0.3), 0 8px 8px rgba(0, 0, 0, 0.2)",
          transform: "scale(1.01)",
          borderRadius: "10px",
        }}
      >
        <div style={{ maxHeight: "80vh", overflowY: "auto" }}>
          <Row style={{ paddingBottom: "20px" }}>
            <p className="modal-header-text">Edit Master Suite</p>
          </Row>
          <Row>
            <Col span={6}>
              <p className="spec-modal-label">Display Name * </p>
            </Col>
            <Col span={18}>
              <Form layout="vertical">
                <Form.Item>
                  <Input
                    placeholder="display name"
                    value={props.displayName}
                    disabled={true}
                  />
                </Form.Item>
              </Form>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <p className="spec-modal-label">Default Environment * </p>
            </Col>
            <Col span={18}>
              <DropdownSelect
                placeholder="select environment"
                labelKey="displayName"
                valueKey="displayName"
                options={environments}
                onSelect={onEnvironmentChange}
                value={defaultEnvironment}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: "10px" }}>
            <Col span={24}>
              <MasterSuiteCopyTable
                suiteArray={taskList}
                testSuiteList={suiteList}
                uiSuiteList={uiSuiteList}
                refreshTaskData={refreshTaskData}
                newlyCreatedTask={newlyCreatedTask}
                resetNewlyCreatedTask={resetNewlyCreatedTask}
                environments={environments}
                defaultEnvironment={defaultEnvironment}
                folderPaths={environmentFolderPath}
                displayName={displayName}
                onSave={handleSaveData}
                existingData={props.existingData}
              />
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  );
}

export default MasterSuiteCopyModal;
